import { Style } from 'ol/style';
import { LocalGroupInfo } from '@/store/modules/user';

export default abstract class AbstractGeoItem<T, R, K, KR> {
  abstract dataToObjKey(inputData: T, userGroupInfo: LocalGroupInfo | null): R;
  abstract objKeyToColor(inputData: K, userGroupInfo: LocalGroupInfo | null): KR;
  abstract objKeyToFeatureStyle(inputData: K, userGroupInfo: LocalGroupInfo | null): Style | Style[];
}
